import { z } from 'zod';

export const ReceptionBelongingsItemSchema = z.object({
  tag: z.string().trim().min(1).max(100),
  custom: z.boolean(),
});

export type ReceptionBelongingsItem = z.infer<typeof ReceptionBelongingsItemSchema>;

export const ReceptionBelongingsSnapshotSchema = z.array(ReceptionBelongingsItemSchema);

export type ReceptionBelongingsSnapshot = z.infer<typeof ReceptionBelongingsSnapshotSchema>;
